/**
 * <p-card-swatches> — Varianten-Swatches der Puschies-Produktkarte (snippets/p-product-card.liquid).
 * Port von Hyper `color-swatch` (theme.js): Hover auf einen Swatch tauscht nach 50 ms das
 * Hauptbild der Karte gegen das Variantenbild (data-src/data-srcset) und markiert den Swatch.
 */
if (!customElements.get('p-card-swatches')) {
  class PCardSwatches extends HTMLElement {
    connectedCallback() {
      this.mainImage = this.closest('.p-pcard')?.querySelector('[data-p-pcard-main]');
      if (!this.mainImage) return;
      this.abort = new AbortController();
      this.querySelectorAll('.p-pcard__swatch').forEach((item) => {
        item.addEventListener('mouseenter', () => this.select(item), { signal: this.abort.signal });
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.timer);
    }

    select(item) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.selected?.removeAttribute('aria-selected');
        item.setAttribute('aria-selected', 'true');
        this.selected = item;
        const link = item.querySelector('[data-src]');
        if (!link) return;
        this.mainImage.srcset = link.dataset.srcset;
        this.mainImage.src = link.dataset.src;
      }, 50);
    }
  }

  customElements.define('p-card-swatches', PCardSwatches);
}
